module.exports = __webpack_public_path__ + "img/bh1.b4a83d7c.jpeg";